var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"GoogleSettings mt-1"},[_c('v-select',{staticClass:"mb-3",attrs:{"outlined":"","dense":"","value":_vm.selectedNode.settings.search,"item-text":"name","item-value":"name","items":_vm.availableInputFields,"label":"Search Query","clearable":""},on:{"input":(val) => _vm.onUpdate(val, 'settings.search')}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }